import { extractStringValueSet } from './extract-properties';

export default class Disease {

    static readonly Cancer: string = 'cancer';
    static readonly Depression: string = 'depression';
    static readonly InfectiousDiseases: string = 'infectious-diseases';
    static readonly Cardiovascular: string = 'cardiovascular';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
